<template>
  <div class="send-message">
    <textarea
      class="send-message-textarea"
      :placeholder="translate('chat', 'Ваше сообщение', {})"
      v-model="message"
      @keydown="printMessage"
      @keyup.enter="submit"
    />
    <button class="submit send-message-submit" type="submit" @click="submit" />
  </div>
</template>

<script>

export default {
  props: {
    sendMessage: {
      type: Function,
      default: () => {}
    },
    mainUser: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      message: "",
      print: false
    };
  },
  watch: {
    print: function() {
      if (this.print) {
        socket.emit(
          "chat typing",
          {
            username: this.mainUser.userName,
            userId: this.mainUser.userId,
            key: this.orderId,
            type: 1
          },
          data => {}
        );
        this.checkPrint();
      }
    }
  },
  methods: {
    submit: function() {
      this.sendMessage(this.message);
      this.message = "";
    },
    printMessage: function(e) {
      if (!this.print) {
        this.print = true;
      }
    },
    checkPrint: function() {
      setTimeout(() => {
        this.print = false;
      }, 2000);
    },
    translate(source, message, params) {
      return translate(source, message, params);
    },
  }
};
</script>

<style lang="scss" scoped>
.send-message {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
  border-top: 1px solid #e1e1e2;
}
.send-message-textarea {
  width: 100%;
  height: 50px;
  padding: 16px 24px;
  font-size: 15px;
  line-height: 18px;
  color: #717070;
  border: none;
  resize: none;
  white-space: nowrap;
  outline: transparent !important;
}
.send-message-submit {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  right: 12px;
  width: 24px;
  height: 20px;
  padding: 0;
  border: none;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMjBMMjQgMTBMMCAwVjcuNzc3NzhMMTcuMTQyOSAxMEwwIDEyLjIyMjJWMjBaIiBmaWxsPSIjNUJDMERFIi8+Cjwvc3ZnPgo=");
  cursor: pointer;
}
</style>
